import React from 'react';
import PropTypes from 'prop-types';
import Assembly from './layout';
import preprocess from './preprocess';

/**
 *  This component is called on page assemblies: fields that hold an array of
 *  components in order.
 *
 *  We find the component that matches our `type` in the `assembly-mapping`.
 *
 *  Components found in the `assembly-mapping` have a `contentfulData` prop,
 *  which transforms the data we provide from Contentful into props that the
 *  underlying UI component can consume.
 *
 *  We use `memo` to prevent unnecessary re-rendering
 */

// eslint-disable-next-line prefer-arrow-callback
const Assemblies = React.memo(function AssembliesComponent({ assemblies }) {
  if (!assemblies || assemblies.length === 0) return null;

  return (
    <>
      {preprocess(assemblies).map((assembly, index) => {
        if (assembly.group) {
          return (
            <assembly.component key={index}>
              {assembly.items.map((item, itemIndex) => (
                <Assembly assembly={item} key={itemIndex} />
              ))}
            </assembly.component>
          );
        }
        return <Assembly assembly={assembly} key={index} />;
      })}
    </>
  );
});

Assemblies.propTypes = {
  assemblies: PropTypes.arrayOf(
    PropTypes.shape({
      internal: PropTypes.shape({
        type: PropTypes.string.isRequired,
      }),
    })
  ),
};

export default Assemblies;

export { default as Assembly } from './layout';
